import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  ɵHttpInterceptingHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpResponse,
} from '@angular/common/http';
import { throwError, Observable, BehaviorSubject, of } from 'rxjs';
import {
  catchError,
  filter,
  take,
  switchMap,
  finalize,
  tap,
  retry,
} from 'rxjs/operators';
// import * as storage from '../../store/storage';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
// import { StorageService } from '../services/shared/storage.shared';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private token: any = '';

  constructor(
    // private storageService: StorageService,
    private router: Router,
    private notificationService : NotificationService
  ) {}

  private AUTH_HEADER = 'Authorization';
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.get('skip')) {
      req = req.clone({
        headers: req.headers.delete('skip'),
      });
      return next.handle(req);
    }
    this.token = sessionStorage.getItem('umiToken');
    if (!req.headers.has('Content-Type')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`,
        },
        // headers: req.headers
        //   .set('Content-Type', 'multipart/form-data')
        //   .set('Content-Type', 'application/json'),
      });
    }
    req = this.addAuthenticationToken(req);
    return next.handle(req).pipe(
      retry(1),
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (evt.status >= 200 && evt.status <= 226) {
            if (evt.body.code && evt.body.code !== 1) {
              // this..publishMessages(
              //   'error',
              //   evt.body.errors.toString() || evt.body.description
              // );
              // this.notificationService.show(evt.body.msg)
            }
          }
        }
      }),
      catchError((_error: HttpErrorResponse) => {
        if (_error) {
          if (_error.status === 401) {
            localStorage.clear();

     
            this.notificationService.publishMessage('error', "Your session has expired!")
            location.href = '/admin/auth';
          }
          if (_error.status === 403) {
            localStorage.clear();
            this.notificationService.publishMessage('error', "You don't have access to this application")


            this.router.navigate(['/']);
          }
          if (_error.status === 404) {
            localStorage.clear();
            this.notificationService.publishMessage('error', _error.error.msg.toString())


            
          }
          if (_error.status === 400) {
            this.notificationService.publishMessage('error', _error.error.msg.toString())
            const { error, errorMessages, error_description } = _error.error;
           
            if (typeof error === 'object') {
              let value = Object.values(error);
              
              this.notificationService.show(error.msg.toString())

            } else {
              
              this.notificationService.show(error.toString)

            }
          }

          if (this.refreshTokenInProgress) {
            return this.refreshTokenSubject.pipe(
              filter((result) => result !== null),
              take(1),
              switchMap(() => next.handle(this.addAuthenticationToken(req)))
            );
          } else {
            this.refreshTokenInProgress = true; 
            this.refreshTokenSubject.next(null);
            return this.refreshAccessToken().pipe(
              switchMap((success: boolean) => {
                this.refreshTokenSubject.next(success);
                return next.handle(this.addAuthenticationToken(req));
              }),
              
              finalize(() => (this.refreshTokenInProgress = false))
            );
          }
        } else {
          return throwError(_error);
        }
      })
    );
  }

  private refreshAccessToken(): Observable<any> {
    return of(sessionStorage.getItem('refreshToken'));
  }
  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    if (!this.token) return request;
    if (!request.url.match(/www.example.com\//)) return request;
    return request.clone({
      headers: request.headers.set(this.AUTH_HEADER, 'Bearer ' + this.token),
    });
  }
}

